/**
 * Tax label helpers: IN = keep CGST/SGST (no change per requirement);
 * other countries = use only database tax1_name (no hardcoded fallback).
 */

export const isIndia = (country) => (country || "IN") === "IN";

/**
 * Label for the first tax field (settings): "CGST + SGST" for IN, else database tax1_name only.
 */
export const getTax1Label = (country, tax1Name) =>
  isIndia(country) ? "CGST + SGST" : (tax1Name ?? "");

/**
 * Label for a tax row (CGST half): "CGST" for IN, else database tax1_name only.
 */
export const getCGSTLabel = (country, tax1Name) =>
  isIndia(country) ? "CGST" : (tax1Name ?? "");

/**
 * Label for a tax row (SGST half): "SGST" for IN, else database tax1_name only.
 */
export const getSGSTLabel = (country, tax1Name) =>
  isIndia(country) ? "SGST" : (tax1Name ?? "");

/**
 * Full row label e.g. "CGST(2.5%)" or "VAT(2.5%)".
 */
export const getTaxRowLabel = (country, tax1Name, percentage, isCGST = true) => {
  const name = isCGST ? getCGSTLabel(country, tax1Name) : getSGSTLabel(country, tax1Name);
  return `${name}(${percentage}%)`;
};
